export const categoryOrBrand = (categories, brands) => {
    const pathname = window.location.pathname;

    let items;
    let path = "";

    if (pathname.includes("category")) {
        items = categories;
        path = "categoria"
    } else {
        items = brands;
        path = "marca"
    }

    if (!Array.isArray(items)) return path;

    return items?.[0]?.label || path;

};